import React from "react";
import { Plus, Minus } from "BaseComponents/Icons/Svg";
import { useTransition, animated } from "react-spring";

export const MenuButtonIcons = ({ IsExpanded, ShouldAnimate }) => {
	const transitions = useTransition(null, null, {
		from: {
			transform: "rotate(90deg)",
			opacity: 1,

			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		enter: {
			transform: "rotate(0deg)",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			opacity: 1,
		},
		leave: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			opacity: 0,
		},
	});

	return ShouldAnimate ? (
		transitions.map(({ item, key, props }) =>
			!IsExpanded ? (
				<animated.div key={key} style={props}>
					<Plus />
				</animated.div>
			) : (
				<animated.div key={key} style={props}>
					<Minus />
				</animated.div>
			)
		)
	) : IsExpanded ? (
		<Minus />
	) : (
		<Plus />
	);
};
